const AD_QUALITY_API_URL = process.env.REACT_APP_AD_QUALITY_API_URL || 'https://4uigfcwzfwl7re3gndt3i4oqdm0dvijd.lambda-url.us-east-1.on.aws';

export async function analyzeUrl(url) {
	try {
		const params = new URLSearchParams({ url });
		const response = await fetch(`${AD_QUALITY_API_URL}?${params}`, {
			method: 'POST',
		});

		// Check for server errors (500+)
		if (response.status >= 500) {
			throw new Error(`Server error: The analysis service is temporarily unavailable. Please try again in a few moments.`);
		}

		// Check for other non-OK responses
		if (!response.ok) {
			let errorMessage = `Analysis failed (Status ${response.status})`;
			try {
				const errorData = await response.json();
				errorMessage = errorData.body || errorMessage;
			} catch {
				// If response isn't JSON, use the generic error message
			}
			throw new Error(errorMessage);
		}

		// Try to parse JSON response
		let data;
		try {
			data = await response.json();
		} catch (jsonError) {
			console.error('Failed to parse response as JSON:', jsonError);
			throw new Error('The analysis service returned an invalid response. Please try again.');
		}

		console.log('Raw API response:', data);
		
		if (data.status === 200 && data.body) {
			return data; // Return the full response object with status, source, and body
		} else {
			throw new Error(data.body || 'The analysis results are incomplete. Please try again.');
		}
	} catch (error) {
		// Re-throw with a user-friendly message if it's a network error
		if (error instanceof TypeError && error.message.includes('fetch')) {
			throw new Error('Unable to connect to the analysis service. Please check your internet connection and try again.');
		}
		console.error('Ad Quality API Error:', error);
		throw error;
	}
}

export function validateUrl(url) {
	try {
		const urlObj = new URL(url);
		return urlObj.protocol === 'http:' || urlObj.protocol === 'https:';
	} catch {
		return false;
	}
}

export function getMetricStatus(ratio) {
	if (ratio <= 0.15) return 'good';
	if (ratio <= 0.30) return 'warning';
	return 'critical';
}

export function formatRefreshRate(rate) {
	if (!rate || rate === 0) return 'No refresh detected';
	if (rate < 60) return `${rate.toFixed(1)} seconds`;
	return `${(rate / 60).toFixed(1)} minutes`;
}

export function calculateAdNetworkRatio(adCalls, totalCalls) {
	if (!totalCalls || totalCalls === 0) return 0;
	return ((adCalls / totalCalls) * 100).toFixed(1);
}